import {
  Caption,
  Skeleton
} from "@livingdesign/react";
import React, { useEffect, useState } from "react";
import { createUseStyles } from "react-jss";
import { useSelector } from "react-redux";
import { amountFormat } from "../../../../../helpers/commonUtils";
import MuiDataTable from "../../../../../components/Table/MuiDataTable/MuiDataTable";;

/**
 * styles used in the component.
 */
const useStyles = createUseStyles({
  overviewTitleHead: {
    margin: "0",
    paddingBottom: "16px",
    fontSize: "24px",
    lineHeight: "36px",
  },
  overviewSubTitle: {
    fontSize: "20px",
    lineHeight: "1.4",
    color: "#2e2f32",
    fontWeight: "bold",
    marginBottom: "8px",
    marginTop: "0"
  },
  overviewTotalBudget: {
    fontSize: "14px",
    color: "#2e2f32;",
  },
  overviewLineSpace: {
    margin: "24px 0",
    opacity: "30%",
  }
});

/**
* OverviewTask component used to view overview tab for sub-type "Task"
*
*/
const OverviewTask = () => {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const { budgetDetail } = useSelector(state => state?.budget);
  const [budgetTasks, setBudgetTasks] = useState([]);

  const codeCustomBodyRender = (value, tableMeta) => {
    return <Caption as="p" id={`Mui-code-row-${tableMeta?.rowIndex}`}>{value}</Caption>
  }

  const budgetAmountCustomBodyRender = (value, tableMeta) => {
    return <div id={`table-row-budget-${tableMeta?.rowIndex}`} className={classes.amountStyle}>{value ? `$${amountFormat(value)}` : "--"}</div>
  }

  const numberOfHoursCustomBodyRender = (value, tableMeta) => {
    return <div id={`table-row-hours-${tableMeta?.rowIndex}`} className={classes.amountStyle}>{value ? `$${amountFormat(value)}` : "--"}</div>
  }
  const COLUMNS = [
    {
      name: "code",
      label: "Code",
      colKey: "code",
      options: {
        sort: true,
        customBodyRender: codeCustomBodyRender,
      },
    },
    {
      name: "displayName",
      label: "Display Name",
      colKey: "displayName",
      options: {
        sort: true,
        customBodyRender: (value, tableMeta) => <div id={`table-row-displayName-row-${tableMeta?.rowIndex}`}>{value}</div>,
      },
    },
    {
      name: "budgetAmount",
      label: "$ Budget",
      colKey: "budgetAmount",
      options: {
        sort: true,
        customBodyRender: budgetAmountCustomBodyRender
      },
    },
    {
      name: "numberOfHours",
      label: "Hours",
      colKey: "numberOfHours",
      options: {
        sort: true,
        customBodyRender: numberOfHoursCustomBodyRender
      },
    },
    {
      name: "paidAmount",
      label: "$ Spend",
      colKey: "paidAmount",
      options: {
        sort: false,
        customBodyRender: budgetAmountCustomBodyRender
      },
    },
    {
      name: "balanceAmount",
      label: "$ Balance",
      colKey: "balanceAmount",
      options: {
        sort: false,
        customBodyRender: budgetAmountCustomBodyRender
      },
    },
  ];

  const [budgetTaskColumns, setBudgetTaskColumns] = useState(COLUMNS);

  useEffect(() => {
    if (budgetDetail !== "") {

      setBudgetTasks(budgetDetail?.budgetTasks);
      setLoading(false);
    }
  }, [budgetDetail]);

  const taskCustomOptions = {
    responsive: "standard",
    totalCount: budgetTasks ? budgetTasks?.length : 0,
  };

  return (
    <div data-testid="OverviewTask">
      <h2 className={classes.overviewTitleHead} id="budget-task-overview">Task</h2>
      {loading === false ?
        <>
          <div className={classes.dataTableWrap} data-testid="tasks-list">
            <MuiDataTable
              data={budgetTasks}
              columns={budgetTaskColumns}
              setTableColumns={setBudgetTaskColumns}
              customOptions={taskCustomOptions}
              onRowClick={() => { }}
              groupFilter={false}
              onExportClick={() => { }}
              onRowSelection={() => { }}
              onAddNew={() => { }}
              loading={loading}
              showRowsCounter={false}
              disableSearch={true}
              disableFilter={true}
              disablePagination={true}
              disableExport={true}
              hideAddNewButton={true}
            />
          </div>
        </>
        :
        <Skeleton height="20px" variant="rectangle" width="100%" />}

    </div>
  )
}

export default OverviewTask;